import { supabase } from '@/lib/supabase'
import type { Tables } from '@/types/database.types'

export type Document = Tables<'documents'>
export type DocumentType = 'passport' | 'visa' | 'insurance' | 'other'

export interface NewDocumentInput {
  tripId: string
  type: DocumentType
  fileUrl: string
  expirationDate?: string
}

export async function listDocuments(tripId: string): Promise<Document[]> {
  const { data, error } = await supabase
    .from('documents')
    .select('*')
    .eq('trip_id', tripId)
    .order('expiration_date', { nullsFirst: false })
  if (error) throw error
  return data
}

export async function createDocument(input: NewDocumentInput): Promise<Document> {
  const { data, error } = await supabase
    .from('documents')
    .insert({
      trip_id: input.tripId,
      type: input.type,
      file_url: input.fileUrl,
      expiration_date: input.expirationDate,
    })
    .select()
    .single()
  if (error) throw error
  return data
}

export async function deleteDocument(documentId: string): Promise<void> {
  const { error } = await supabase.from('documents').delete().eq('id', documentId)
  if (error) throw error
}
